import React from "react";

function KPIPopup({
  title,
  data,
  closePopup,
}) {

  if (!data) return null;

  return (
    <div className="popup-overlay">

      <div className="popup-content">

        <button
          className="close-btn"
          onClick={closePopup}
        >
          X
        </button>

        <h2>{title}</h2>

        {data.length === 0 ? (
          <div className="popup-empty">
            No matching products were found for this KPI.
            Try clearing filters or changing the current view.
          </div>
        ) : (
          <table>
          <thead>
            <tr>
              <th>Product</th>
              <th>Category</th>
              <th>Quantity</th>
              <th>Unit</th>
              <th>F2B</th>
              <th>Blinkit</th>
              <th>Zepto</th>
              <th>BigBasket</th>
              <th>Cheapest</th>
              <th>Difference %</th>
            </tr>
          </thead>

          <tbody>

            {data.map((item, index) => (

              <tr key={index}>

                <td>
                  {item.master_product}
                </td>

                <td>
                  {item.master_category}
                </td>

                <td>
                  {item.quantity_value || "-"}
                </td>

                <td>
                  {item.quantity_unit || "-"}
                </td>

                <td>
                  ₹ {item.farm2bag_price || 0}
                </td>

                <td>
                  ₹ {item.blinkit_price || 0}
                </td>

                <td>
                  ₹ {item.zepto_price || 0}
                </td>

                <td>
                  ₹ {item.bigbasket_price || 0}
                </td>

                <td>
                  {item.cheapest_platform}
                </td>

                <td>
                  {item.price_difference_pct || 0}%
                </td>

              </tr>

            ))}

          </tbody>
        </table>
        )}

      </div>
    </div>
  );
}

export default KPIPopup;